import { registerFinalizeReducerKey } from './RegisterFinalizeConstants';

export function registerFinalize(state) {
  return state.get(registerFinalizeReducerKey);
}

export function ipAddress(state) {
  return registerFinalize(state).get('ipAddress');
}

export function isLoading(state) {
  return registerFinalize(state).get('isLoading');
}

export function marketingInfo(state) {
  return registerFinalize(state).get('marketingInfo');
}

export function data(state) {
  return registerFinalize(state).get('data');
}

export function registerFinalizeFail(state) {
  return registerFinalize(state).get('registerFinalizeFail');
}
